import { render, staticRenderFns } from "./CountryNotice.vue?vue&type=template&id=7605f83b&scoped=true"
import script from "./CountryNotice.vue?vue&type=script&lang=js"
export * from "./CountryNotice.vue?vue&type=script&lang=js"
import style0 from "./CountryNotice.vue?vue&type=style&index=0&id=7605f83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7605f83b",
  null
  
)

export default component.exports